export var graphData = {
    methods: {
        getYaxis: function () {
            return {
                type: 'value',
                scale: true,
                splitLine: {
                    show: false
                },
                axisTick: {
                    show: false
                },
                axisLabel: {
                    // formatter: "{a} <br/>{b}: {c} %",
                    // formatter: isNormalized ? this.normalizedAxisFormatter : this.axisFormatter,
                    margin: 5
                },
            }
        },
    },
    computed: {
        lineGraph: function () {
            return {
                title: {
                    show: true,
                    color: '#000',
                    // padding: 20,
                },
                tooltip: {
                    trigger: 'axis',
                    // formatter: function (params) {
                    //     var temp = '';
                    //     temp = temp + params[0].name + '</br>';     //displayed triggered x-axis
                    //     for (var i = 0; i < params.length; i++) {
                    //         temp = temp + params[i].marker + params[i].seriesName + ' ' + (params[i].value == undefined ? '-' : params[i].value) + (params[i].value == undefined ? ' ' : '%') + '</br>';
                    //     }
                    //     return temp;
                    // },
                    formatter: `Profit/Loss : {c} </br> Strike Price : {b}` 
                },
                legend: {
                    show: true,
                    data: this.lineGraphLegends
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                visualMap: {
                    top: 25,
                    right: 20,
                    pieces: [
                        {
                            gt: 0,
                            lte: this.seriesMaxValue < 0 ? 10 : this.seriesMaxValue,
                            color: '#a0eda0',
                            label: 'Profit'
                        }
                    ],
                    outOfRange: {
                        color: '#f0b6b6',
                        label: 'Loss'
                    }
                },

                yAxis: this.lineGraphYaxis,
                xAxis: this.lineGraphXaxis,
                color: this.graphColors,
                series: this.lineGraphSeries,
            }
        },
    },
    data() {
        return {
            lineGraphLegend: {
                type: 'scroll',
                itemGap: 20,
                top: 10,
                show: true,
            },
            graphColors: ['#ff6b45', '#d340be', '#ff408e', '#db2e4c', '#08beac', '#d8000'],
            lineGraphLegends: [],
            lineGraphSeries: [],
            lineGraphYaxis: {
                type : 'value',
                // axisLabel : {
                //   formatter: '{value} °C'
                // },
                name: 'Profit / Loss',
                nameLocation: 'middle',
                nameGap: 40,
                axisLabel: {
                    formatter: function (value) {
                        return value / 1000 + 'k'
                    },
                    // margin: 40
                },
                axisTick: {
                    show: false,
                },
                axisLine: {
                    show: false,
                },
                type: 'value',
                scale: true,
                splitLine: {
                    show: true,
                    lineStyle: {
                        color: ['#ccc'],
                        width: 1,
                        type: 'dotted',
                    }
                },
            },
            lineGraphXaxis: {
                name:'Price',
                axisTick: {
                    show: false,
                },
                axisLine: {
                    show: false,
                },
                type: 'category',
                boundaryGap: false,
                data: [],
                scale: true,
                min: 0,
                max: '',
                
            },
            initOptions: { renderer: 'svg' },
            loading: true,
            seriesMinValue: -1000,
            seriesMaxValue: 1000,
        }
    }
}
